module.exports = __webpack_public_path__ + "img/logo.12465ef3.png";